import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n          margin: 0;\n          padding: 0;\n          border: 0;\n          background: none;\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { darken } from "polished";
var StyledLink = /*#__PURE__*/ styled("a", {
    target: "er62v7h0"
})("display:inline-flex;align-items:center;column-gap:0.25rem;color:", function(param) {
    var theme = param.theme, variant = param.variant, blendIn = param.blendIn, $disabled = param.$disabled;
    if ($disabled) {
        return "#b6bfc1";
    }
    if (blendIn) {
        return "inherit";
    }
    return variant === "secondary" ? theme.color.natural70 : theme.color.primary;
}, ";font:inherit;text-decoration:", function(param) {
    var variant = param.variant, blendIn = param.blendIn, $disabled = param.$disabled;
    if ($disabled) {
        return "none";
    }
    return variant === "text" || blendIn ? "underline" : "none";
}, ";text-underline-offset:0.125rem;transition:text-underline-offset 0.2s linear;cursor:", function(param) {
    var $disabled = param.$disabled;
    return $disabled ? "" : "pointer";
}, ";pointer-events:", function(param) {
    var $disabled = param.$disabled;
    return $disabled ? "none" : "";
}, ";&:hover{color:", function(param) {
    var theme = param.theme;
    return theme.color.primary100;
}, ";text-decoration:", function(param) {
    var blendIn = param.blendIn;
    return blendIn ? "none" : "underline";
}, ";}&:focus-visible{border-radius:0.5rem;outline:0.125rem dashed ", function(param) {
    var theme = param.theme;
    return theme.color.natural70;
}, ";outline-offset:0.25rem;text-decoration:", function(param) {
    var blendIn = param.blendIn;
    return blendIn ? "none" : "underline";
}, ";}&:active{color:", function(param) {
    var theme = param.theme;
    return darken(0.08, theme === null || theme === void 0 ? void 0 : theme.color.primary);
}, ";text-decoration:", function(param) {
    var blendIn = param.blendIn;
    return blendIn ? "none" : "underline";
}, ";text-underline-offset:0.25rem;}", function(param) {
    var as = param.as;
    return as === "button" ? css(_templateObject()) : "";
});
export { StyledLink };
